import { create as l } from "zustand";
import { devtools as g, subscribeWithSelector as d } from "zustand/middleware";
import { produce as n } from "immer";
const c = (t) => t.length === 2, S = (t) => {
  const s = t.getBounds(), e = s.getNorthEast().toArray(), r = s.getSouthWest().toArray();
  if (!c(e) || !c(r))
    throw new Error("This should never happen because toArray() returns an array of 2 numbers");
  return {
    viewState: {
      longitude: t.getCenter().lng,
      latitude: t.getCenter().lat,
      zoom: t.getZoom(),
      bearing: t.getBearing(),
      pitch: t.getPitch(),
      padding: t.getPadding()
    },
    ne: e,
    sw: r,
    neGuru: [...e].reverse().toString(),
    swGuru: [...r].reverse().toString()
  };
}, h = l()(
  g(
    d((t, s) => ({
      maps: {},
      actions: {
        initMapStore: ({ mapId: e, mapRef: r, initialPrintViewState: o }) => {
          const a = s().maps;
          if (a && a[e]) {
            console.warn(
              `Map ID: ${e} already exists within the PLMapboxViewstateStore`
            );
            return;
          }
          if (o) {
            t(
              n((i) => {
                i.maps[e] = {
                  debouncedViewstate: o,
                  throttledViewstate: o
                };
              }),
              !1,
              `initMapStore - ${e}`
            );
            return;
          }
          const u = S(r);
          t(
            n((i) => {
              i.maps[e] = {
                debouncedViewstate: u,
                throttledViewstate: u
              };
            }),
            !1,
            `initMapStore - ${e}`
          );
        },
        deleteMapStore: (e) => {
          t(
            n((r) => {
              delete r.maps[e];
            }),
            !1,
            `deleteMapStore - ${e}`
          );
        },
        isMapStoreLoaded: (e) => {
          var o;
          return !!((o = s().maps) == null ? void 0 : o[e]);
        },
        setViewState: ({ mapId: e, viewstateType: r, viewstate: o }) => {
          t(
            n((a) => {
              a.maps[e][r] = o;
            }),
            !1,
            `setViewState - ${r} - ${e}`
          );
        }
      }
    })),
    {
      name: "PLMapboxViewstateStore",
      enabled: !1
    }
  )
);
export {
  S as getPLViewStateFromMapRef,
  h as usePLMapboxViewstateStore
};
//# sourceMappingURL=index.es4.js.map
